/*@ngInject*/
const ClearSubmissionRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.markSubmissionClear = function (submissionId, isClear, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/markClearance',
            config = {
                params: {
                    isRiskClear: isClear,
                    reason: reason,
                    detail: detail,
                    notification: notificationConstant.email.NONE
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };

    this.revertToClear = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/revertToClear',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('clearSubmissionRepository', ClearSubmissionRepository);
